var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 4.11613C21.1819 4.475 20.3101 4.71287 19.4013 4.82837C20.3363 4.27012 21.0499 3.39287 21.3854 2.3355C20.5136 2.85525 19.5511 3.22237 18.5254 3.42725C17.6976 2.54587 16.5179 2 15.2309 2C12.7339 2 10.7236 4.02675 10.7236 6.51138C10.7236 6.86888 10.7539 7.21262 10.8281 7.53987C7.0785 7.357 3.76063 5.55988 1.53175 2.82225C1.14262 3.49738 0.914375 4.27012 0.914375 5.102C0.914375 6.664 1.71875 8.04863 2.91775 8.85025C2.19313 8.8365 1.48225 8.62612 0.88 8.29475C0.88 8.3085 0.88 8.32638 0.88 8.34425C0.88 10.536 2.44337 12.3565 4.4935 12.7759C4.12637 12.8762 3.72625 12.9244 3.311 12.9244C3.02225 12.9244 2.73075 12.9079 2.45712 12.8474C3.0415 14.6335 4.69975 15.9466 6.6715 15.9893C5.137 17.1896 3.18863 17.9129 1.07938 17.9129C0.7095 17.9129 0.35475 17.8964 0 17.851C1.99787 19.1394 4.36562 19.875 6.919 19.875C15.2185 19.875 19.756 13 19.756 7.04075C19.756 6.84137 19.7491 6.64888 19.7395 6.45775C20.6346 5.8225 21.3867 5.02912 22 4.11613Z",
    fill: "#FDF4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.d78a54f969cdebf89565e41ee4c19e4a.svg";
export { ForwardRef as ReactComponent };